import logoBB from '../images/bb-logo.svg'
import logoBBmob from '../images/mobile-menu-logo.svg'
import logoLF from '../images/lovefreund.de-logo.svg'
import logoLFmob from '../images/lovefreund-white.png'

const settings = {
    en : {
        formApi : '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',
        listIds : [ 6 ],
        googleMetrics : 'UA-172029576-1',
        wpSiteUrl : 'https://wp.bedbible.com',
        logo : logoBB,
        mobileLogo : logoBBmob,
        lang : 'en-US',
        copyrights : 'Copyright © 2025 BedBible.com',
        becomeTester : '/how-to-become-sex-toy-reviewer/',
        authorsEmail : 'mailto:sextoys@bedbible.com',
        socials : [
            { name : 'youtube', url : 'https://www.youtube.com/c/BedBible/' },
            { name : 'facebook', url : 'https://www.facebook.com/bedbibleofficial/' },
            { name : 'twitter', url : 'https://twitter.com/BedBible/' },
            { name : 'pinterest', url : 'https://www.pinterest.com/Bedbible/' },
            { name : 'instagram', url : 'https://www.instagram.com/bedbibleofficial/' },
            { name : 'linkedin', url : 'https://www.linkedin.com/company/bedbible/' },
            { name : 'tiktok', url : 'https://www.tiktok.com/@bedbible' }
        ],
        contactEmails : {
            e1 : 'sextoys@bedbible.com',
            e2 : 'media@bedbible.com',
            e3 : 'collaboration@bedbible.com',
        },
        contactLinks : {
            l1 : '/contact-us/',
            l2 : '/how-we-test/',
            l3 : '/affiliate-disclaimer/',
        },
        headerMenu : [
            { url : null, label : 'Reviews', isMegeMenu: false, isVertical : true, childrenItems : [
                { url : '/vibrators/', label : 'Vibrators', childrenItems : [
                    { url : '/vibrator/', label : 'Best Vibrators' },
                    { url : '/vibrators-for-beginners/', label : 'Vibrators for Beginners' },
                    { url : '/rabbit-vibrator/', label : 'Rabbit Vibrators' },
                    { url : '/vibrating-egg/', label : 'Vibrating Eggs' },
                    { url : '/magic-wand-vibrator/', label : 'Wand Vibrators' },
                    { url : '/clit-sucker/', label : 'Clit Suckers' },
                    { url : '/g-spot-vibrator/', label : 'G-spot Vibrators' },
                ]},
                { url : '/dildos/', label : 'Dildos', childrenItems : [
                    { url : '/dildo/', label : 'Best Dildos' },
                    { url : '/suction-cup-dildos/', label : 'Suction Cup Dildos' },
                    { url : '/realistic-dildos/', label : 'Realistic Dildos' },
                    { url : '/fantasy-dildos/', label : 'Fantasy Dildos' },
                    { url : '/best-dildos-for-beginners/', label : 'Dildos for Beginners' },
                    { url : '/vibrating-dildo/', label : 'Vibrating Dildos' },
                    { url : '/double-dildo/', label : 'Double Dildos' },
                ]},
                { url : '/couples-toys/', label : 'Couples’ toys', childrenItems : [
                    { url : '/best-couples-sex-toys-vibrator/', label : 'Couple Toys' },
                    // { url : '/sexual-board-games/', label : 'Sexual Board Games' },
                    { url : '/remote-control-vibrator/', label : 'Remote control vibrators' },
                    { url : '/vibrating-cock-ring/', label : 'Vibrating Cock Rings' },
                    { url : '/sex-swings/', label : 'Sex Swings' },
                    { url : '/strap-on/', label : 'Strap Ons' },
                    { url : '/vibrating-panties/', label : 'Panty vibrators' },
                ]},
                { url : '/penis-toys/', label : 'Penis toys', childrenItems : [
                    { url : '/male-masturbators/', label : 'Masturbators' },
                    { url : '/blowjob-machine/', label : 'Blowjob Machines' },
                    { url : '/sex-dolls/', label : 'Sex Dolls' },
                    { url : '/cock-rings/', label : 'Cock Rings' },
                    { url : '/penis-vibrator/', label : 'Penis Vibrators' },
                    { url : '/penis-pumps/', label : 'Penis Pumps' },
                    { url : '/fleshlight/', label : 'Fleshlight' },
                ]},
                { url : '/anal/', label : 'Anal', childrenItems : [
                    { url : '/anal-toys/', label : 'Anal Toys' },
                    { url : '/butt-plug/', label : 'Butt Plugs' },
                    { url : '/prostate-massager/', label : 'Prostate Massagers' },
                    { url : '/best-in-test-10-awesome-anal-dildos/', label : 'Anal Dildos' },
                    { url : '/anal-vibrator/', label : 'Anal Vibrators' },
                    { url : '/anal-beads/', label : 'Anal Beads' },
                    // { url : '/anal-douche/', label : 'Anal Douches' },
                ]},
                { url : '/bdsm/', label : 'BDSM', childrenItems : [
                    { url : '/bdsm-toys/', label : 'BDSM Toys' },
                    { url : '/nipple-clamps/', label : 'Nipple Clamps' },
                    { url : '/bdsm-restraints-for-bondage/', label : 'Bondage Restraints' },
                    { url : '/sex-bed-straps/', label : 'Sex Bed Straps' },
                    { url : '/flogger/', label : 'Floggers' },
                    { url : '/chastity-cage-the-best-cages-for-your-cock/', label : 'Chastity Cages' },
                    { url : '/ball-gags/', label : 'Ball Gags' },
                ]},
                { url : '/better-sex/', label : 'Better sex', childrenItems : [
                    // { url : '/best-new-sex-toys/', label : 'New Sex Toy Reviews' },
                ]},
                { url : '/lubes', label : 'Lubes', childrenItems : [
                    { url : '/best-lubes', label : 'Best Lubes' },
                    { url : '/best-water-based-lubes', label : 'Best Water-Based Lubes' },
                    { url : '/silicone-lube', label : 'Best Silicone Lubes' },
                    { url : '/best-warming-lubes', label : 'Best Warming Lubes' }
                ]}
            ] },
            { url : '/blog/', label : 'Blog', childrenItems : [] },
            { url : null, label : 'About', isVertical : true, childrenItems : [
                { url : '/about-us/', label : 'About us' },
                { url : '/testers-page/', label : 'Bedbible Testers' },
                { url : '/how-we-test/', label : 'How we test' },
                // { url : '/complaints-and-recalls/', label : 'Recalls' },
                { url : '/contact-us/', label : 'Contact us' },
            ] },
            { url : '/how-to-become-sex-toy-reviewer/', label : 'Test Sex Toys?', childrenItems : [] }
        ],
        firstfooterMenu : [
            { url : '/about-us/', label : 'About us' },
            { url : '/how-we-test/', label : 'How we test' },
            // { url : '/write-for-us/', label : 'Write for us' },
            { url : '/contact-us/', label : 'Contact us' },
            { url : '/legal-disclaimer/', label : 'Legal disclaimer' },
            { url : '/privacy-policy/', label : 'Privacy policy' },
            { url : '/affiliate-disclaimer/', label : 'Affiliate disclaimer' },
            { url : '/ethics-statement/', label : 'Ethics Statement' },
        ],
        secondFooterMenu : [
            { url : '/vibrators/', label : 'Vibrators' },
            { url : '/dildos/', label : 'Dildos' },
            { url : '/couples-toys/', label : 'Couples’ toys' },
            { url : '/penis-toys/', label : 'Penis toys' },
            { url : '/anal/', label : 'Anal' },
            { url : '/bdsm/', label : 'BDSM' },
            { url : '/better-sex/', label : 'Better sex' },
        ],
        thirdFooterMenu : [
            { url : '/statistics/', label : 'Statistics' },
            { url : '/free-erotic-images/', label : 'Free Erotic Images' },
            { url : '/podcast/', label : 'Podcast' },
            { url : '/how-to-become-sex-toy-reviewer/', label : 'Become a tester' },
            // { url : '/adult-site-reviews/', label : 'Adult Site Reviews' },
            // { url : '/best-sex-toys/', label : 'Best Sex Toys' },
            { url : '/sex-toy-quiz/', label : 'Sex Toy Quiz' },
            { url : '/vr/', label : 'VR Reviews' }
        ],
        pageMenu : {
            vibMenu : { menuItems : { nodes : [ 
                { url : '/vibrator/', label : 'Best Vibrator' },
                { url : '/vibrators-for-beginners/', label : 'Best Vibrators for Beginners' },
                { url : '/rabbit-vibrator/', label : 'Best Rabbit Vibrator' },
                { url : '/vibrating-egg/', label : 'Best Vibrating Egg' },
                { url : '/magic-wand-vibrator/', label : 'Best Magic Wand Vibrator' },
                { url : '/clit-sucker/', label : 'Best Clit Sucker' }
            ] } },
            dilMenu : { menuItems : { nodes : [
                { url : '/suction-cup-dildos/', label : 'Best Suction Cup Dildo' },
                { url : '/realistic-dildos/', label : 'Best Realistic Dildo' },
                { url : '/fantasy-dildos/', label : 'Best Fantasy Dildo' },
                { url : '/best-dildos-for-beginners/', label : 'Best Dildos for Beginners' },
                { url : '/vibrating-dildo/', label : 'Best Vibrating Dildo' },
                { url : '/double-dildo/', label : 'Best Double Dildo' }
            ] } },
            penMenu : { menuItems : { nodes : [
                { url : '/blowjob-machine/', label : 'Best Blowjob Machine' },
                { url : '/sex-dolls/', label : 'Best Sex Doll' },
                { url : '/cock-rings/', label : 'Best Cock Ring' },
                { url : '/penis-vibrator/', label : 'Best Penis Vibrator' },
                { url : '/penis-pumps/', label : 'Best Penis Pump' },
                { url : '/fleshlight/', label : 'Best Fleshlight' }
            ] } },
            couMenu : { menuItems : { nodes : [
                { url : '/best-couples-sex-toys-vibrator/', label : 'Best Couples Vibrator' },
                { url : '/long-distance-sex-toy/', label : 'Best Long Distance Sex Toy' },
                { url : '/remote-control-vibrator/', label : 'Best Remote Control Vibrator' },
                { url : '/vibrating-cock-ring/', label : 'Best Vibrating Cock Ring' },
                { url : '/sex-swings/', label : 'Best Sex Swing' },
                { url : '/strap-on/', label : 'Best Strap On' }
            ] } },
            analMenu : { menuItems : { nodes : [
                { url : '/anal-toys/', label : 'Best Anal Toys' },
                { url : '/butt-plug/', label : 'Best Butt Plug' },
                { url : '/prostate-massager/', label : 'Best Prostate Massager' },
                { url : '/best-in-test-10-awesome-anal-dildos/', label : 'Best Anal Dildo' },
                { url : '/anal-vibrator/', label : 'Best Anal Vibrator' },
                { url : '/anal-beads/', label : 'Best Anal Beads' }
            ] } },
            bdsmMenu : { menuItems : { nodes : [
                { url : '/nipple-clamps/', label : 'Best Nipple Clamps' },
                { url : '/bdsm-restraints-for-bondage/', label : 'Best BDSM Restraints' },
                { url : '/sex-bed-straps/', label : 'Best Sex Bed Strap' },
                { url : '/flogger/', label : 'Best Flogger' },
                { url : '/chastity-cage-the-best-cages-for-your-cock/', label : 'Best Chastity Cage' },
                { url : '/ball-gags/', label : 'Best Ball Gag' }
            ] } }
        }
    },
    de : {
        formApi : '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',
        listIds : [ 5 ],
        googleMetrics : 'UA-185994154-1',
        wpSiteUrl : 'https://wp.lovefreund.de',
        logo : logoLF,
        mobileLogo : logoLFmob,
        lang : 'de-DE',
        copyrights : 'Copyright © 2025 Lovefreund.de',
        becomeTester : '/sexspielzeuge-testen/',
        authorsEmail : 'mailto:kontakt@lovefreund.de',
        socials : [
            { name : 'facebook', url : 'https://www.facebook.com/Lovefreundde-104590568141733/' },
            { name : 'instagram', url : 'https://www.instagram.com/lovefreund.de/' },
        ],
        contactEmails : {
            e1 : 'sexspielzeug@lovefreund.de',
            e2 : 'presse@lovefreund.de',
            e3 : 'zusammenarbeit@lovefreund.de',
        },
        contactLinks : {
            l1 : '/kontaktiere-uns/',
            l2 : '/impressum-datenschutz/',
            l3 : '/sexspielzeuge-testen/',
        },
        headerMenu : [
            { url : '/ueber-uns/', label : 'Über uns', childrenItems : [] },
            { url : null, label : 'Bewertungen', isVertical : true, childrenItems : [
                { url : '/sexspielzeug-fur-frauen/', label : 'Frauen' },
                { url : '/sexspielzeug-fur-manner/', label : 'Männer' },
                { url : '/sexspielzeug-fur-paare/', label : 'Paare' },
                { url : '/anal/', label : 'Anal' },
                { url : '/bdsm-spielzeug/', label : 'BDSM' },
                { url : '/erotische-webseiten/', label : 'Erotikseiten' }
                // { url : '/marken/', label : 'Marken' }
            ] },
            { url : '/blog/', label : 'Blog', childrenItems : [] },
            { url : '/testerseite/', label : `Tester’innen`, childrenItems : [] },
            { url : '/sexspielzeuge-testen/', label : `Sexspielzeuge testen?`, childrenItems : [] }
        ],
        firstfooterMenu : [
            { url : '/ueber-uns/', label : 'Über uns' },
            { url : '/kontaktiere-uns/', label : 'Kontaktiere uns' },
            { url : '/impressum-datenschutz/', label : 'Impressum & Datenschutz' },
            { url : '/sexspielzeuge-testen/', label : 'Tester werden' },
            // { url : '/sex-shop-deutschland/', label : 'Sex Shop Deutschland' },
            { url : '/sexspielzeuge-gutscheincode-und-rabattcode/', label : 'Rabattcodes' },
            { url : '/kostenlose-erotische-bilder-copyright-freie/', label : 'Kostenlose Bilder' },
        ],
        secondFooterMenu : [
            { url : '/sexspielzeug-fur-frauen/', label : 'Frauen' },
            { url : '/sexspielzeug-fur-manner/', label : 'Männer' },
            { url : '/sexspielzeug-fur-paare/', label : 'Paare' },
            { url : '/anal/', label : 'Anal' },
            { url : '/bdsm-spielzeug/', label : 'BDSM' },
            { url : '/erotische-webseiten/', label : 'Erotikseiten' }
            // { url : '/marken/', label : 'Marken' },
        ],
        thirdFooterMenu : [],
        pageMenu : {
            vibMenu : { menuItems : { nodes : [
                { url : '/vibrator/', label : 'Bester Vibrator' },
                { url : '/auflegevibrator/', label : 'Bester Auflegevibrator' },
                { url : '/druckwellenvibrator/', label : 'Bester Druckwellenvibrator' },
                // { url : '/ferngesteuertes-vibro-ei/', label : 'Bestes ferngesteuertes Vibro Ei' },
                { url : '/vibrator-mit-fernbedienung/', label : 'Bestes ferngesteuertes Vibrator' },
                { url : '/vibrator-fuer-anfaenger/', label : 'Bester vibrator für Anfänger' }
            ] } },
            dilMenu : { menuItems : { nodes : [
                { url : '/dildo/', label : 'Bester Dildo' },
                { url : '/spritzdildo/', label : 'Beste Spritzdildo' },
                { url : '/bester-realistischer-dildo/', label : 'Bester realistischer Dildo' },
                { url : '/dildo-mit-saugnapf/', label : 'Bester Dildo mit Saugnapf' },
                { url : '/dildo-vibrator/', label : 'Bester Dildo Vibrator' }
            ] } },
            penMenu : { menuItems : { nodes : [
                { url : '/fleshlight/', label : 'Beste Fleshlight' },
                { url : '/sexpuppen/', label : 'Beste Sexpuppen' },
                { url : '/penisringe/', label : 'Bester Penisring' },
                { url : '/taschenmuschi/', label : 'Beste Taschenmuschi' },
                { url : '/penispumpe/', label : 'Beste Penispumpe' }
            ] } },
            couMenu : { menuItems : { nodes : [
                { url : '/liebesschaukel/', label : 'Beste Liebesschaukel' },
                { url : '/strapon/', label : 'Bester Strapon' },
                { url : '/slip-vibrator/', label : 'Bester Slip Vibrator' },
                { url : '/paarvibrator/', label : 'Bester Paarvibrator' },
                { url : '/erotik-und-sex-adventskalender/', label : 'Sexspielzeug Adventskalender' }
            ] } },
            analMenu : { menuItems : { nodes : [
                { url : '/prostata-vibrator/', label : 'Bester Prostata Vibrator' },
                { url : '/buttplug/', label : 'Beste Buttplug' },
                { url : '/analplug/', label : 'Bester Anal plug' },
                { url : '/analkette/', label : 'Beste Analkette' },
                { url : '/analvibrator/', label : 'Bester Analvibrator' }
            ] } },
            bdsmMenu : { menuItems : { nodes : [
                { url : '/bondage-set/', label : 'Beste Bondage Set' },
                { url : '/fickmaschine/', label : 'Beste Fickmaschine' },
                { url : '/sm-moebel/', label : 'Beste BDSM Möbel' },
                { url : '/flogger/', label : 'Bester Flogger' },
                { url : '/peniskafig/', label : 'Bester Peniskäfig' }
            ] } }
        }
    }
}

export default settings